module.exports = __webpack_public_path__ + "img/alipay.3f334361.png";